
import {translations} from '@/mixins'
import {Banner as BannerApi} from "@/services/SOLO";
import {
  BanAttributes,
  SlideAttributes,
  Banner,
  Slide,
  BanDesc,
  BanTitle,
  BanLinkLabel,
  BanImgUri,
} from "@/models";
import {Select, Option} from "element-ui";
import {ValidationProvider} from "vee-validate";
import {Component, ProvideReactive, Prop, Vue, Watch, Emit,} from "vue-property-decorator";
import {mapGetters} from 'vuex'

@Component({
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ValidationProvider,
  },
  computed: {
    ...mapGetters({
      getLocale: 'app/getLocale',
      getConceptSettings: 'account/getConceptSettings',

    }),
  },
  mixins: [translations],
})
export default class CreateBannerItem extends Vue {
  applyBoth: Boolean = true;
  saving: Boolean = false
  arrayLang: Array<string> = [];
  menuID: any = "";
  advanceSettings: any = false;
  banTitle: BanTitle = {};
  banDesc: BanDesc = {};
  banImgUri: BanImgUri = {};
  menus: Array<Slide> = [];
  linkOptions: Array<any> = [];
  menu_id: number = 0;
  imageType: any = {};
  imageTypes: any = [
    {
      value: 0,
      text: "Image URL",
    },
    {
      value: 1,
      text: "Upload IMG",
    },
  ];
  linkTypes: any = [
    {value: "url", text: "URL"},
    {value: "category", text: "Category"},
    {value: "item", text: "Item"},
    {value: "cms-page", text: "CMS-PAGE"},
  ];
  imageValuePrimary: string = '';
  imageValueSecondary: string = '';
  tmpImageValuePrimary: string = '';
  tmpImageValueSecondary: string = '';
  fileValue: any = {};
  $notify: any;
  $refs!: {
    file: any;
  };
  public translate!: Function
  getConceptSettings: any
  @Prop() open!: Boolean;
  bannerID!: any;
  getLocale!: any;
  bannerslider: SlideAttributes = {
    label: "",
    status: "",
    description: {},
    title: {},
    link: "",
    "display-order": "",
    "link-type": "category",
    "link-value": "",
    "link-label": {},
    "image-uri": {},
  };

  @Watch("fileValue", {immediate: true, deep: true})
  checkPrimaryUpload(newVal: any) {
    if (newVal[this.getConceptSettings.attributes['primary-language']]) {
      if(this.applyBoth) {
        if(this.fileValue[this.getConceptSettings.attributes['primary-language']]) {
          this.fileValue[this.getConceptSettings.attributes['secondary-language']] = this.fileValue[this.getConceptSettings.attributes['primary-language']];
        }
      }

    } else {
      if(this.applyBoth) {
        if(this.fileValue[this.getConceptSettings.attributes['secondary-language']]) {
          this.fileValue[this.getConceptSettings.attributes['primary-language']] = this.fileValue[this.getConceptSettings.attributes['secondary-language']];
        } 
      }
    }
  }



  @Watch("imageValuePrimary", {immediate: true, deep: true})
  checkPrimary(newVal: any) {
    if (newVal) {
      if(this.applyBoth) {
        this.imageValueSecondary = this.imageValuePrimary;
      }
    }
  }

  @Watch("imageValueSecondary", {immediate: true, deep: true})
  checkSecondary(newVal: any) {
    if (newVal) {
      if(this.applyBoth) {
        this.imageValuePrimary = this.imageValueSecondary;
      }
    }
  }

  constructor() {
    super();
  }

  mounted() {
    this.getMenus()
    this.bannerID = this.$route.params.id
    /* @ts-ignore */
    if(this.getConceptSettings.attributes['primary-language']) {
      /* @ts-ignore */
      this.arrayLang.push(this.getConceptSettings.attributes['primary-language']);
    }

    /* @ts-ignore */
    if(this.getConceptSettings.attributes['secondary-language']) {
      /* @ts-ignore */
      this.arrayLang.push(this.getConceptSettings.attributes['secondary-language']);
    }

    for (let i in this.arrayLang) {
      this.imageType[this.arrayLang[i]] = 0;
    }
    this.imageValuePrimary = "";
    this.imageValueSecondary = "";
  }

  created() {
    this.imageTypes = [
      {value: 0, text: this.translate("Image URL")},
      {value: 1, text: this.translate("Upload IMG")},
    ];
    this.linkTypes = [
      {value: "url", text: this.translate("URL")},
      {value: "category", text: this.translate("Category")},
      {value: "item", text: this.translate("Item")},
      {value: "cms-page", text: this.translate("CMS-PAGE")}
    ];
  }

  get isOpen(): Boolean {
    return this.open;
  }

  set isOpen(newVal: Boolean) {
    this.$emit("modal:add", newVal);
    if (!newVal) {
    }
  }

  handleClick() {
    // eslint-disable-next-line no-alert
    alert('button click')
  }

  openAdvanceSettings() {
    if(this.advanceSettings == false) {
      this.advanceSettings = true;
    } else {
      this.advanceSettings = false;
    }
  }

  resetForm() {
    this.bannerslider["display-order"] = "";
    this.bannerslider["link-type"] = "";
    this.bannerslider["link-value"] = "";
    this.bannerslider.label = "";

    this.bannerslider.title = {};
    this.bannerslider.description = {};

    this.bannerslider["link-label"] = {};
    this.bannerslider["image-uri"] = {};
  }

  get bannerSliderData(): SlideAttributes {
    return this.bannerslider;
  }

  resetImage(type: number, lang: string) {
    if (type == 0) {
      /* @ts-ignore */
      if (this.getConceptSettings.attributes['primary-language'] == lang) {
        this.imageValuePrimary = this.tmpImageValuePrimary;
      /* @ts-ignore */
      } else if (this.getConceptSettings.attributes['secondary-language']) {
        this.imageValueSecondary = this.tmpImageValueSecondary;
      }
      // this.imageValue[lang] = this.tmpImageValue;
      this.fileValue[lang] = null;
    } 
    if (type == 1) {
      /* @ts-ignore */
      if (this.getConceptSettings.attributes['primary-language'] == lang) {
        this.tmpImageValuePrimary = this.imageValuePrimary;
        this.imageValuePrimary = '';
      /* @ts-ignore */
      } else if (this.getConceptSettings.attributes['secondary-language'] == lang) {
        this.tmpImageValueSecondary = this.imageValueSecondary;
        this.imageValueSecondary = '';
      }
      // this.tmpImageValue = this.imageValue[lang];
      // this.imageValue[lang] = null;
    }
  }

  checkSize(text: any) {

    if(this.getLocale === 'en_US') {
        if(text === 'The image field size must be less than 2000KB') {
          return 'The image file size must be less than 2MB'
        }
    }
    if(text === 'The image field size must be less than 2000KB') {
          return 'يجب أن يكون حجم ملف الصورة أقل من 2 ميغا بايت'
    }

  }

  getMenus() {
    BannerApi.menus().then((response: any) => {
      this.menus = response.data.data;
    });
  }

  onMenuSearch(): void {
    this.onChangeLinkType();
  }

  onChangeLinkType(): void {
    this.bannerslider['link-value'] = '';
    const { menuID } = this;
    if (this.bannerslider['link-type'] === 'item' && menuID) {
      BannerApi.linkValueSearch(menuID, 'items', 1)
        .then((response) => (this.linkOptions = response.data.data));
    } else if (this.bannerslider['link-type'] === 'category' && menuID) {
      BannerApi.linkValueSearch(menuID, 'categories', 1)
        .then((response) => (this.linkOptions = response.data.data));
    }
  }

  formatData() {
    let formData = new FormData();
    formData.append("link-type", this.bannerslider["link-type"]);
    formData.append("link-value", this.bannerslider["link-value"]);
    formData.append(
        "display-order",
        this.bannerslider["display-order"].toString()
    );

    let count = 0;
    for (let i in this.arrayLang) {
      if (this.fileValue && this.fileValue[this.arrayLang[i]]) {
        if (count == 0) {
          formData.append("image", this.fileValue[this.arrayLang[i]]);
        } 
        if (count == 1) {
          formData.append("alt-image", this.fileValue[this.arrayLang[i]]);
        }
      } else {
        /* @ts-ignore */
        formData.append(`image-uri[${this.getConceptSettings.attributes['primary-language']}]`, this.imageValuePrimary);
        /* @ts-ignore */
        formData.append(`image-uri[${this.getConceptSettings.attributes['secondary-language']}]`, this.imageValueSecondary);
      }
      count += 1
    }
    return formData;
  }

  cancelCreate() {
    this.resetForm()
    this.$router.go(-1);
  }

  showNotifyStatus(status: Boolean, msg: string = '') {
    if (status) {
      this.$notify({
        title: "BANNER SLIDE SAVED!",
        verticalAlign: "bottom",
        horizontalAlign: "left",
        message: msg || "Banner slide created successfully.",
        type: "success",
        icon: "fas fa-check",
      });
    } else {
      this.$notify({
        title: "An Error Occured in Creating Banner",
        verticalAlign: "bottom",
        horizontalAlign: "left",
        message: msg || "Something went wrong, please try again!",
        type: "danger",
        icon: "fas fa-bomb",
      });
    }
  }
  
  async createBannerSlides() {
    try {
      this.saving = true
      await BannerApi.createBannerSlide(this.formatData(), this.bannerID)
      /* @ts-ignore */
      analytics.track('add_banner', {
        banner_id: this.bannerID,
      });
      this.showNotifyStatus(true)
      this.resetForm()
      this.$router.back()
      /* @ts-ignore */
    } catch (error: any) {
      if (error.response) {
        if (Object.keys(error.response.data.messages)[0]) {
          let errorMsg = error.response.data.messages[Object.keys(error.response.data.messages)[0]][0] || 'An Error Encounter'
          this.showNotifyStatus(false, errorMsg)
        } else {
          this.showNotifyStatus(false, 'Request Entity Too Large')
        }
      } else {
        this.showNotifyStatus(false, 'Request Entity Too Large')
      }
    } finally {
      this.saving = false
    }
  }
}
